import { render, staticRenderFns } from "./GvntLink.vue?vue&type=template&id=61070271&"
import script from "./GvntLink.vue?vue&type=script&lang=js&"
export * from "./GvntLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports